import { Navigate, useLocation } from "react-router";
import { useAccessFeatures } from "@/auth/access-features";
import { FEATURE_CATALOG } from "@/auth/feature-catalog";

export function GrowOverviewRedirect() {
  const { hasFeature, loading } = useAccessFeatures();
  const { search, hash } = useLocation();
  if (loading) return null;
  const pathname = hasFeature(FEATURE_CATALOG.growMap.key)
    ? "/grow/map"
    : hasFeature(FEATURE_CATALOG.growPlay.key)
      ? "/grow/play"
      : hasFeature(FEATURE_CATALOG.growWatch.key)
        ? "/grow/watch"
        : "/";
  return <Navigate to={{ pathname, search, hash }} replace />;
}
